import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Strategy from "@/components/Strategy";
import Positioning from "@/components/Positioning";
import WhyScalehaus from "@/components/WhyScalehaus";
import AuditCTA from "@/components/AuditCTA";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Home() {
    return (
        <div id="top" className="grain bg-ink-900 text-white overflow-x-clip">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Problem />
                <Services />
                <HowItWorks />
                <Strategy />
                <Positioning />
                <WhyScalehaus />
                <AuditCTA />
                <FAQ />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
